export const Gender = {
  female: 1,
  male: 2,
};
